export const offerModal = {
  state: {
    show: false,
    data: null,
  },
  mutations: {
    open(state, data) {
      state.data = data;
      state.show = true;
    },
    close(state) {
      state.data = null;
      state.show = false;
    },
  },
  actions: {
    open({ commit }, data) {
      commit("open", data);
    },
    close({ commit }) {
      commit("close");
    },
  },
};
